import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "../Pages/Views/Employee/CheckInOut/checkInPage.module.less";
import {
    Body_16_Coral_Primary_Regular_16,
    Title_20_Coral_Strong_emphasis_20
} from "@UI/typography/generated/typography.tsx";
import {Gt} from "@src/i18n/Gt.tsx";
import cn from "classnames";
import {PageNotFound} from "@UI/illustrationsSvg/PageNotFound.tsx";
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";
import {Redo} from "@UI/components/icons/Redo.tsx";
import {Checked} from "@UI/components/icons/Checked.tsx";


interface ModalProps {
    skipAction: () => void
    retryAction: () => void
}


export const GPSFailModal = ({skipAction, retryAction}: ModalProps) => {
    return (
        <Stack grow alignItems={"center"} justifyContent={"center"} direction={"column"} gap={16}
               className={styles.checkPopup}>
            <PageNotFound/>
            <Stack direction={"column"} alignItems={"center"} style={{width: "273px"}}>
                <Stack className={styles.title} alignItems={"center"} justifyContent={"center"}>
                    <Title_20_Coral_Strong_emphasis_20>
                        <Gt>The timestamp has been recorded!</Gt>
                    </Title_20_Coral_Strong_emphasis_20>
                </Stack>
                <Stack className={cn(styles.title, styles.errorText)} alignItems={"center"} justifyContent={"center"}>
                    <Body_16_Coral_Primary_Regular_16>
                        <Gt>Location information could not be obtained</Gt>
                    </Body_16_Coral_Primary_Regular_16>
                </Stack>
            </Stack>

            <Stack style={{flexWrap: "wrap"}} className={styles.buttons} justifyContent={"center"}>
                <Button type={ButtonType.third} icon={<Checked/>} onClick={skipAction} className={styles.popupButton}>
                    <Gt>Save without coordinates</Gt>
                </Button>
                <Button type={ButtonType.primary} icon={<Redo size={20}/>} onClick={retryAction} className={styles.popupButton}>
                    <Gt>Reacquisition</Gt>
                </Button>
            </Stack>
        </Stack>
    )
}